import graphql from "babel-plugin-relay/macro";

const AllPartyQuery = graphql`
query AllPartyQuery{
  allParties{
    edges{
      node{
        id
        partyName
        partyImage    
        priceDiffPercentage
      }
    }
  }
}
`

export default AllPartyQuery
// priceDiffPercentage